<template>
  <footer class="footer bg-pg-footer-btm">
    <div class="container">
      <hr class="mt-0 pt-0 bg-white" />
      <div class="row align-items-center text-center text-md-left justify-content-md-between">
        <div class="col-12 col-md-6">
          <div class="text-white">
            &copy; {{year}}
            <router-link to="/">
              <span class="text-white">NightMorning Studios Sdn Bhd (1195783-A)</span>
            </router-link>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <ul class="nav nav-footer justify-content-md-end">
            <li class="nav-item d-block mx-auto mx-md-0 mt-3 mt-md-0">
              <a target="_blank" rel="noopener" href="https://www.facebook.com/nightmorninggames">
                <img src="images/FindUs-FB-RGB-Wht-1067.png" width="120px" />
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div class="col-12">
            <div class="text-white">
              <router-link to="/privacy">
                <span class="text-white font-weight-normal">Privacy Policy</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>
.footer {
  margin-top: -7%;
}
</style>
